// app/services/commonCode.service.js
import { api } from './api';

class CommonCodeService {
    // Get all common codes or by type
    async getCommonCodes(codeType = null, activeOnly = true) {
        const params = { active_only: activeOnly };
        if (codeType) {
            params.code_type = codeType;
        }
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/api/admin/common-codes?${queryString}`);
    }

    // Create new common code
    async createCommonCode(codeData) {
        return api.post('/api/admin/common-codes', codeData);
    }

    // Update common code
    async updateCommonCode(codeId, codeData) {
        return api.put(`/api/admin/common-codes/${codeId}`, codeData);
    }

    // Delete common code
    async deleteCommonCode(codeId) {
        return api.delete(`/api/admin/common-codes/${codeId}`);
    }

    // Get code types
    async getCodeTypes() {
        const data = await this.getCommonCodes();
        return Object.keys(data);
    }
}

export const commonCodeService = new CommonCodeService();